//Testnet & Dev mode

// module.exports = {
//   loginurl: 'Dashboard',
//   baseurl: '/',
//   tutorial: '/tutorial',
//   myprofile: '/profile',
//   ApiURL: 'http://localhost:9090/api/',
//   //ApiURL: 'https://infi.espsofttech.org/api/',
// };

//++++++++++++++++++++++Mainnet client server+++++++++++++++++++++

module.exports = {
  loginurl: 'Dashboard',
  baseurl: '/ico/',
  tutorial: '/ico/tutorial',
  myprofile: '/ico/profile',
  // ApiURL: 'http://localhost:9090/api/',
  ApiURL: 'https://infimultichain.com/api/',
};
